import Personas from './Personas';

export default Personas;
